module.exports = __webpack_public_path__ + "static/media/Program12.f8efff32.jpg";